var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h3',[_vm._v(_vm._s(_vm.menuName))]),_c('el-button',{staticClass:"btn-logout",nativeOn:{"click":function($event){return _vm.logOut.apply(null, arguments)}}},[_vm._v("退出")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }